export default __webpack_public_path__ + "static/media/develop.dff21d2f.svg";